import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./PayStar.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import LogItem from "../../comm/global/components/LogItem";

const PayStar = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    useEffect(() => {
        setInProp(true);
    }, [])

    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "PayStar"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.box}>
                                    <YStyled.Span size={28} fontFamily="SF Pro" style={{}}>2</YStyled.Span>
                                    <YStyled.Span size={15} fontWeight={400} style={{}}>你目前有2個星星空間可上傳回顧</YStyled.Span>
                                    <YStyled.BTN5 style={{ background: "white", padding: ".4rem .8rem" }} onClick={e => {
                                    }}>
                                        <YStyled.Span size={15} fontWeight={400} style={{}}>購買星星</YStyled.Span>
                                    </YStyled.BTN5>
                                    <img src="./assets/ui/star3.png" />
                                </div>
                                <img className={styleUi.back} src="./assets/ui/back.png" onClick={e => {
                                    setInProp(false);
                                }} />
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(PayStar);